<ng-container *ngIf="hanja">
  <app-hanja-content [hanjas]="hanja.hanja"
                     [selected]="selected"></app-hanja-content>

  <div class="info-box">
    <div *ngFor="let saseung of getSasaeung(hanja.saseungs ?? [])"
         class="row-box">
      <div class="label-box"><span class="label-txt">{{ GetSaseungTxt(saseung.saseung) }}성</span></div>
      <app-hun-content class="kr-box"
                       [content]="saseung.meaning2 | resize"
                       [pronunciation]="saseung.hangul"></app-hun-content>
    </div>
  </div>
</ng-container>
